<rt-dialog-header [heading]="'app.support_fab.contact_sales' | translate" />
<rt-dialog-body>
  <div class="content">
    <div class="infobox">
      <div class="infobox-icon">
        <svg
          width="24"
          height="24"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M23.9785 25.6464C23.9785 26.7227 23.812 27.498 23.4773 27.9724C23.1424 28.4467 22.6252 28.6839 21.9255 28.6839C21.2258 28.6839 20.7567 28.4547 20.4218 27.9962C20.0871 27.5378 19.9206 26.8642 19.9206 25.9773V16.6715H29.0827L30.1393 10.7361H19.9187V5L12.4687 8.04146V10.7381H8.57129C8.57129 13.2913 10.1952 15.4617 12.4687 16.2989V26.1208C12.4687 28.0202 12.8276 29.6346 13.5433 30.964C14.259 32.2934 15.3015 33.2979 16.6708 33.9795C18.0401 34.6592 19.7423 35 21.7812 35C23.82 35 25.418 34.6193 26.8675 33.86C28.3149 33.1006 29.4376 32.0323 30.2335 30.6551C31.0295 29.2778 31.4284 27.6734 31.4284 25.8358V20H23.9785V25.6464Z"
            fill="var(--color-icon-impact-default)"
          />
        </svg>
      </div>
      <span>
        <strong>{{ 'app.support_fab.contact_sales_infobox_heading' | translate }}</strong>
        {{ 'app.support_fab.contact_sales_infobox_body' | translate }}
      </span>
    </div>
    @if (formError()) {
      <div class="form-error">
        <p>{{ 'app.support_fab.contact_sales_form_error' | translate }}</p>
        <a
          [href]="'app.support_fab.contact_sales_url' | translate"
          target="_blank"
          rel="noopener noreferrer"
          class="form-error-link"
        >
          {{ 'app.support_fab.contact_sales_form_error_link' | translate }}
        </a>
      </div>
    } @else {
      @if (loading()) {
        <div class="loading">
          <rt-spinner />
        </div>
      }
      <div #formContainer [class.hidden]="loading()"></div>
      @if (!loading()) {
        <div class="response-time">
          {{ 'app.support_fab.contact_sales_response_time' | translate }}
        </div>
      }
    }
  </div>
</rt-dialog-body>
